/**
 * Screen pixels per logical stage pixel (see hiDpiRenderer.ts).
 *
 * Pure: no Phaser, so the art helpers and their tests can use it.
 */
import { GAME_HEIGHT, GAME_WIDTH } from '../types';

/** Beyond this the fill cost climbs and the eye stops seeing a difference. */
export const STAGE_RESOLUTION_CAP = 3;

let chosen: number | null = null;

/** The resolution for a device ratio and window size; 1 to the cap. */
export function stageResolutionFor(
  devicePixelRatio: number,
  width: number,
  height: number,
): number {
  const ratio = Number.isFinite(devicePixelRatio) && devicePixelRatio > 0 ? devicePixelRatio : 1;
  const fit = Math.min(width / GAME_WIDTH, height / GAME_HEIGHT);
  const raw = ratio * (Number.isFinite(fit) && fit > 0 ? fit : 1);
  return Math.min(STAGE_RESOLUTION_CAP, Math.max(1, Math.round(raw * 100) / 100));
}

/**
 * The device ratio times how far FIT scales the stage up to fill the window.
 * Chosen once at startup, so the canvas, the art and the text all agree on
 * one number for the whole session.
 */
export function stageResolution(): number {
  if (chosen !== null) return chosen;
  if (typeof window === 'undefined') return 1;
  chosen = stageResolutionFor(window.devicePixelRatio, window.innerWidth, window.innerHeight);
  return chosen;
}
